import React,{useState} from "react";
import  * as Style from "./styles/inputTax";
import { defaultStyles } from "../../../constants/style-constants/utils";

function InputTax(props) {
  const {setSelectedValue,type,selectedValue,onChange,value,name} = props.value || props
  const { styles } = defaultStyles;

  return (
    <div>
      <Style.Input
        style={styles.textInput.extraSmallTextInput}
        type={type ? type : "text"}
        name={name}
        value={value}
        onChange={onChange}
        // placeholder={"Enter Order Tracking ID..."}
      />
    </div>
  );
}

export default InputTax;
